const PENDING_STATUSES = ["PENDING", "PROCESSING"]

export const pollTaskStatus = ({
  fetchStatus,
  onSuccess,
  onError,
  onException,
  interval = 1000,
  backoff = 1,
  maxInterval = Infinity,
  maxErrors = 1,
}) => {
  let cancelled = false
  let timeoutId = null
  let delay = interval
  let errors = 0

  const scheduleNext = () => {
    timeoutId = setTimeout(poll, delay)
    delay = Math.min(delay * backoff, maxInterval)
  }

  const poll = async () => {
    if (cancelled) return

    let response

    try {
      response = await fetchStatus()
    } catch (e) {
      if (cancelled) return

      errors += 1

      if (errors >= maxErrors) {
        onException?.(e)
      } else {
        scheduleNext()
      }

      return
    }

    if (cancelled) return

    errors = 0

    if (response.status === "SUCCESS") {
      onSuccess(response)
    } else if (response.status === "ERROR") {
      onError(response)
    } else if (PENDING_STATUSES.includes(response.status)) {
      scheduleNext()
    } else {
      console.warn(`[pollTaskStatus] Unhandled status: "${response.status}"`)
    }
  }

  scheduleNext()

  return () => {
    cancelled = true
    clearTimeout(timeoutId)
  }
}
